import { useMemo } from 'react';

import { useIntl } from 'react-intl';

import { Drawer } from 'antd';

import BoxContainer from '@src/components/BoxContainer';
import Title from '@src/components/BoxContainer/components/Title';
import FilterContainer from '@src/components/FilterContainer';
import DeliveryStatus from '@src/components/MemberList/DeliveryStatus';
import { ResponsiveTable } from '@src/components/Table';

/**
 * UsersTableDrawer component displays a list of users in a table.
 *
 * @param {Object} props - The component props.
 * @param {boolean} props.isVisible - Whether the drawer is visible.
 * @param {Function} props.onCancel - Callback function to close the drawer.
 * @param {Object[]} props.users - The list of users to display.
 * @returns {JSX.Element} The UsersTableDrawer component.
 */
export const UsersTableDrawer = ({ isVisible, onCancel, users = [] }) => {
  const intl = useIntl();
  const columns = useMemo(
    () => [
      {
        key: 'displayName',
        title: intl.formatMessage({ id: 'dashboards.deviations.column.userOrUserGroup' }),
        dataIndex: 'displayName',
        render: record => {
          return <div>{`${record?.firstName} ${record?.lastName}`}</div>;
        },
      },
      {
        key: 'groupName',
        title: intl.formatMessage({ id: 'dashboards.deviations.column.group' }),
        dataIndex: 'groupName',
        render: record => {
          return <div>{record?.groupName || '-'}</div>;
        },
      },
      {
        key: 'viewed',
        title: intl.formatMessage({ id: 'dashboards.deviations.column.viewed' }),
        dataIndex: 'deliveryState',
        render: record => {
          return <DeliveryStatus status={record?.deliveryState} />;
        },
      },
    ],
    [intl],
  );
  return (
    <Drawer destroyOnClose open={isVisible} closable={false} footer={null}>
      <BoxContainer>
        <BoxContainer content bottomBorder fixed>
          <FilterContainer goBack={onCancel} title={<Title.Header value="Users" />} />
        </BoxContainer>
        <BoxContainer content>
          <div className="gx-pt-4">
            <ResponsiveTable dataSource={users} columns={columns} />
          </div>
        </BoxContainer>
      </BoxContainer>
    </Drawer>
  );
};
